<template>
  <VUEModal v-if="Popup" :Titolo="this.GetTraduzioneLabel('Generic','TKN_AVVISO',this.LinguaUtente)" :Programma="Programma" :Altezza="'100px'" :Larghezza="'500px'"
            @onClickChiudiModal="ChiudiPopup">
    <template v-slot:Body>
      <p>{{Richiesta}}</p>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-info" style="float:right;margin-left:10px;font-weight:bold;width:15%" @click="ChiudiPopup" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CHIUDI',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>
</template>

<script>

import VUEModal from '@/utils/VUEModal.vue';
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import { SystemInformation } from '@/SystemInformation';
export default 
{
  mixins: [ MixInsGestioneTraduzioni ],
  data()
  {
   return {
            LinguaUtente : SystemInformation.UserInformation.Lingua
   }
  },
  props : ['Richiesta', 'Popup', 'Programma', 'Larghezza'],
  emits : ['OnClickChiudiPopup'],
  components: { VUEModal },
  methods :
  {
    ChiudiPopup()
    {
      this.$emit('OnClickChiudiPopup')
    }
  }
}
</script>
